module.exports = __webpack_public_path__ + "img/chest-open.196222d8.png";